angular.module('picmonicng').directive('plsScrubHandle', [
  'LearnService',
  function (LearnService) {
    return {
      restrict: 'A',
      link: function (scope, element, attr) {
        function dragStop(data) {
        if (LearnService.locked) return;
          LearnService.seek(
            ((data.target.offsetLeft + data.target.clientWidth / 2) /
              data.target.offsetParent.parentElement.clientWidth) *
              LearnService.audioElement.duration
          );
          LearnService.determineFact();
          scope.$apply();
          element.css('left', '');
        }

        element.draggable({
          axis: 'x',
          //helper: "clone",
          containment: '.audio-time-bar',
          refreshPositions: true,
          //start:dragStart,
          stop: dragStop,
          //handle: ctrl.useHandle ? '.pls-list-item__image' : false
        });
      },
    };
  },
]);
